/**
 * @file   src\utils\constants.ts
 * @brief  This file is responsible define constants.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */


export const STATUS_200 = 200;
export const STATUS_401 = 401;
export const STATUS_403 = 403;
export const STATUS_500 = 500;
export const API_TIMEOUT = 30000;
export const API_MAXCONTENTLENGTH = 1000;
export const API_REFRESH_TOKEN_ERROR = 1003;
export const STATUS_498 = 498;
export const API_REDIRECTS = 5;
// export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(?!com\.com)([a-zA-Z]{2,6})(\.[a-zA-Z]{2,6})?$/
export const EMAIL_MAX_LENGTH = 50;
export const PASSWORD_MAX_LENGTH = 100
export const MIN_PASSWORD_LENGTH = 8
export const WASH_NAME_MAX_LENGTH = 150
export const LOCATION_NAME_MAX_LENGTH = 50
export const WASH_ADDRESS_MAX_LENGTH = 200
export const WASH_DETAIL_MAX_LENGTH = 300
export const WASH_NUMBER_MAX_LENGTH = 3
export const AMOUNT_MAX_LENGTH = 10
export const CITY_MAX_LENGTH = 50
export const ZIP_MAX_LENGTH = 9
export const NAME_MAX_LENGTH = 50
export const ACCOUNT_NAME_MAX_LENGTH = 50
export const ACCOUNT_NUMBER_MAX_LENGTH = 17
export const ROUTING_NUMBER_MAX_LENGTH = 9
export const PHONE_MAX_LENGTH = 14;
export const PHONE_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/;
export const EQUIPMENT_NAME_MAX_LENGTH = 50
export const INTERNET_CONNECTIVITY_MAX_LENGTH = 50
export const DEVICE_ID_MAX_LENGTH = 50
export const BRAND_PAY_STATION_MAX_LENGTH = 50
export const EQUIPMENT_TYPE_MAX_LENGTH = 50
export const CVV_MAX_LENGTH = 3
export const CARD_NUMBER_MAX_LENGTH = 19
export const CARD_Expiry_MAX_LENGTH = 5;
export const PROMOTION_NAME_MAX_LENGTH = 150
export const GIFT_CARD_NAME_MAX_LENGTH = 30
export const GIFT_CARD_AMOUNT_MAX_LENGTH = 5
export const PROMOTION_DETAIL_MAX_LENGTH = 300
export const PROMO_CODE_MAX_LENGTH = 4
export const INITIAL_FEE_MAX_LENGTH = 6
export const COMMISSION_MAX_LENGTH = 8;
export const SUBJECT_MAX_LENGTH = 50
export const MESSAGE_MAX_LENGTH = 550;
export const CHARGE_MAX_LENGTH = 8
export const DESCRIPTION_MAX_LENGTH = 300
export const PACKAGE_NAME_LENGTH = 50
export const PACKAGE_DESCRIPTION_LENGTH = 300
export const PACKAGE_PRICE_LENGTH = 6
export const DISCOUNT_MAX_LENGTH = 5
export const ITEM_NAME_LENGTH = 50
export const ITEM_DESCRIPTION_LENGTH = 300
export const ITEM_PRICE_LENGTH = 6
export const REFERRAL_BONUS_LIMIT = 4
export const PERCENTAGE_LIMIT = 3
export const PRIMARY_COLOR = '#0182F0'
export const SECONDARY_COLOR = '#172951'
export const BUTTON_PRIMARY_COLOR = '#FFD500'
export const BUTTON_TEXT_COLOR = '#172951'
export const TEXT_PRIMARY_COLOR = '#000000';
export const THEME1_PRIMARY_COLOR = '#0182F0'
export const THEME1_SECONDARY_COLOR = '#F79420'
export const THEME1_TEXT_COLOR = '#FFFFFF';
export const THEME2_PRIMARY_COLOR = '#E05A00'
export const THEME2_SECONDARY_COLOR = '#FFFFFF'
export const THEME2_TEXT_COLOR = '#000000';
export const THEME3_PRIMARY_COLOR = '#00BF52'
export const THEME3_SECONDARY_COLOR = '#FFFFFF'
export const THEME3_TEXT_COLOR = '#000000';
export const CUSTOM_LOGO_IMAGE_SIZE = 2;
export const CUSTOM_ADVERTISEMENT_IMAGE_SIZE = 2;
export const TITLE_CONTENT_LIMIT = 40;
export const SUBSCRIPTION_CONTENT_LIMIT = 20;

export const MONTHS_OPTIONS = [
  { label: 'January', value: '01' },
  { label: 'February', value: '02' },
  { label: 'March', value: '03' },
  { label: 'April', value: '04' },
  { label: 'May', value: '05' },
  { label: 'June', value: '06' },
  { label: 'July', value: '07' },
  { label: 'August', value: '08' },
  { label: 'September', value: '09' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' },
];

export const TIMEZONE_OFFSET_OPTIONS = [
  { label: '(UTC-12:00) International Date Line West', value: '720' },
  { label: '(UTC-11:00) Coordinated Universal Time-11', value: '660' },
  { label: '(UTC-10:00) Hawaii', value: '600' },
  { label: '(UTC-09:00) Alaska', value: '540' },
  { label: '(UTC-08:00) Pacific Time (US & Canada)', value: '480' },
  { label: '(UTC-07:00) Mountain Time (US & Canada)', value: '420' },
  { label: '(UTC-06:00) Central Time (US & Canada)', value: '360' },
  { label: '(UTC-05:00) Eastern Time (US & Canada)', value: '300' },
  { label: '(UTC-04:00) Atlantic Time (Canada)', value: '240' },
  { label: '(UTC-03:00) Brasilia', value: '180' },
  { label: '(UTC-02:00) Mid-Atlantic', value: '120' },
  { label: '(UTC-01:00) Azores', value: '60' },
  { label: '(UTC+00:00) Dublin, Edinburgh, London', value: '0' },
  { label: '(UTC+01:00) Amsterdam, Berlin, Rome', value: '-60' },
  { label: '(UTC+02:00) Athens, Bucharest', value: '-120' },
  { label: '(UTC+03:00) Moscow, St. Petersburg', value: '-180' },
  { label: '(UTC+04:00) Abu Dhabi, Muscat', value: '-240' },
  { label: '(UTC+05:00) Islamabad, Karachi', value: '-300' },
  { label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi', value: '-330' },
  { label: '(UTC+06:00) Astana, Dhaka', value: '-360' },
  { label: '(UTC+07:00) Bangkok, Hanoi, Jakarta', value: '-420' },
  { label: '(UTC+08:00) Beijing, Singapore', value: '-480' },
  { label: '(UTC+09:00) Osaka, Sapporo, Tokyo', value: '-540' },
  { label: '(UTC+10:00) Canberra, Melbourne, Sydney', value: '-600' },
  { label: '(UTC+11:00) Magadan, Solomon Is., New Caledonia', value: '-660' },
  { label: '(UTC+12:00) Auckland, Wellington', value: '-720' }
];

